var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preloader-internal"},[_c('infinite-loader',{attrs:{"disabled":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }